var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoneClose = function SvgPhoneClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 34 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M10.228 10.228a.78.78 0 0 1 1.1 0L17 15.9l5.672-5.672a.778.778 0 1 1 1.1 1.1L18.1 17l5.672 5.672a.778.778 0 0 1-1.1 1.1L17 18.1l-5.672 5.672a.778.778 0 0 1-1.1-1.1L15.9 17l-5.672-5.672a.78.78 0 0 1 0-1.1",
    clipRule: "evenodd"
  })));
};
export default SvgPhoneClose;